import debounce from "lodash.debounce";

function init() {
	window.addEventListener("resize", debounce(initTriggers, 300));
	window.addEventListener("load", initTriggers);
}

function initTriggers() {
	let offset = 0;

	// If mobile fixed header showing, get it's height to use as offset
	if (window.innerWidth < 1250) {
		const nav = document.getElementById("site-header-nav");

		if (nav !== null) {
			offset = nav.offsetHeight;
		}
	}

	// Get position of top of content
	const content = document.getElementById("faqs-layout");
	if (content !== null) {
		const scrollingTo = content.getBoundingClientRect().top - offset;
	}

	for (const btn of document.querySelectorAll("[data-faqs-back-to-top]")) {
		btn.addEventListener("click", (e) => {
			window.scrollTo({
				top: scrollingTo,
				behavior: "smooth",
			});
		});
	}
}

export default init;
